import React, { useState } from "react";
import logo from "../../resource/7.png";

const LifelongMembershipForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    wtNumber: "",
    email: "",
    textarea: "",
  });
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };
  return (
    <div className="form-page dark-gold ">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Lifelong Membership Form</h2>
            <h2 className="h4 mt-4">"Yawa Jeewa Kappiyakaraka Dayakathwaya"</h2>
          </div>
        </div>

        <p className="font-p mt-6">
          Please fill in the following details and we will contact you.
        </p>

        <p className="font-p mt-5">Full Name*</p>
        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="firstname"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
            />
            <label htmlFor="firstname">First Name</label>
          </div>
          <div className="form-item">
            <input
              type="text"
              id="lastname"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
            />
            <label htmlFor="firstname">Last Name</label>
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="mobilenumber"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleInputChange}
            />
            <label htmlFor="mobilenumber">Mobile Number</label>
          </div>
          <div className="form-item">
            <input
              type="text"
              id="wtnumber"
              name="wtNumber"
              value={formData.wtNumber}
              onChange={handleInputChange}
            />
            <label htmlFor="wtnumber">
              Mobile Phone Number* (including country code)
            </label>
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
            <label htmlFor="email">Email Address</label>
          </div>
        </div>

        <p className="font-p mt-5">Residential Address*</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="address"
              name="address"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <p className="font-p mt-5">
          Please indicate which following donation you would like to make as
          part of the Monthly Lifelong Membership Contribution.
        </p>

        <div className="selection mt-5">
          <div className="checkbox-box">
            <label htmlFor="birthday"> $20</label>
            <input
              type="checkbox"
              id="birthday"
              name="birthday"
              className="checkbox"
              checked={formData.birthday}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="business"> $50</label>
            <input
              type="checkbox"
              id="business"
              name="business"
              className="checkbox"
              checked={formData.business}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="warming"> $100</label>
            <input
              type="checkbox"
              id="warming"
              name="warming"
              className="checkbox"
              checked={formData.warming}
              onChange={handleInputChange}
            />
          </div>

          <div className="checkbox-box">
            <label htmlFor="warming"> $150</label>
            <input
              type="checkbox"
              id="warming"
              name="warming"
              className="checkbox"
              checked={formData.warming}
              onChange={handleInputChange}
            />
          </div>

          <div className="checkbox-box">
            <label htmlFor="warming"> $250</label>
            <input
              type="checkbox"
              id="warming"
              name="warming"
              className="checkbox"
              checked={formData.warming}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <button type="submit" id="submitbtn" className="mt-5">
          Submit
        </button>
        <p className="font-p mt-5">
          We greatly appreciate your interest in joining the Lifelong Membership
          Fund at Bhaddeka Vihari Monastery.
        </p>
      </form>
    </div>
  );
};

export default LifelongMembershipForm;
